import React from 'react';
import { Fab } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useNavigate } from 'react-router-dom';

export default function NewPacienteFab() {
  const navigate = useNavigate();

  return (
    <Fab
      variant="extended"
      color="primary"
      aria-label="crear paciente"
      onClick={() => navigate('/crear-paciente-user')}
      sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 9999 }}
    >
      <PersonAddIcon sx={{ mr: 1 }} />
      Crear Paciente
    </Fab>
  );
}
